import { render, staticRenderFns } from "./CustomViews.vue?vue&type=template&id=3562ba24&scoped=true&"
import script from "./CustomViews.vue?vue&type=script&lang=js&"
export * from "./CustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562ba24",
  null
  
)

export default component.exports